module.exports = __webpack_public_path__ + "f75569f8a5fab0893fa712d8c0d9c3fe.woff2";